var _circle, _rect, _circle2, _rect2, _circle3, _rect3, _circle4, _rect4, _circle5, _rect5, _circle6, _rect6, _path, _path2, _rect7;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLoadingstatusoperator = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 122,
    viewBox: "0 0 264 122",
    fill: "none",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 14,
    r: 4,
    fill: "#D81B60"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 6,
    width: 100,
    height: 16,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 34,
    r: 4,
    fill: "#5E35B1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 26,
    width: 100,
    height: 16,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 54,
    r: 4,
    fill: "#1E88E5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 46,
    width: 100,
    height: 16,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 74,
    r: 4,
    fill: "#00ACC1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 66,
    width: 100,
    height: 16,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 94,
    r: 4,
    fill: "#43A047"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 86,
    width: 100,
    height: 16,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 114,
    r: 4,
    fill: "#C0CA33"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 106,
    width: 100,
    height: 16,
    rx: 8,
    fill: "black",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.273 60C120.273 49.4145 117.472 39.0175 112.155 29.8641C106.839 20.7107 99.195 13.1268 90.0001 7.88211C80.8052 2.63745 70.3865 -0.081286 59.8014 0.00185051C49.2162 0.084987 38.8415 2.96703 29.7301 8.35548C20.6187 13.7439 13.0951 21.4469 7.92283 30.6827C2.75054 39.9185 0.113717 50.3583 0.279985 60.9424C0.446253 71.5266 3.40969 81.8784 8.86953 90.9471C14.3294 100.016 22.0912 107.479 31.3674 112.578L40.0389 96.8049C33.5456 93.2352 28.1123 88.0111 24.2904 81.663C20.4686 75.3149 18.3942 68.0686 18.2778 60.6597C18.1614 53.2508 20.0072 45.943 23.6278 39.4779C27.2484 33.0129 32.5149 27.6207 38.8928 23.8488C45.2708 20.0769 52.5331 18.0595 59.9427 18.0013C67.3523 17.9431 74.6454 19.8462 81.0818 23.5175C87.5183 27.1887 92.8688 32.4975 96.5905 38.9049C100.312 45.3122 102.273 52.5902 102.273 60H120.273Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.273 60C120.273 70.4257 117.556 80.6714 112.39 89.7275C107.225 98.7836 99.7889 106.337 90.8151 111.645C81.8412 116.952 71.6394 119.829 61.215 119.993C50.7906 120.156 40.5035 117.601 31.3674 112.578L40.0389 96.8049C46.4342 100.321 53.6352 102.109 60.9323 101.995C68.2294 101.88 75.3707 99.8661 81.6523 96.1512C87.934 92.4362 93.1393 87.1485 96.7551 80.8093C100.371 74.47 102.273 67.298 102.273 60H120.273Z",
    fill: "#757575"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7944,
    y: 46.6304,
    width: 53.0869,
    height: 27.2609,
    rx: 13.6304,
    fill: "black",
    fillOpacity: 0.1
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoadingstatusoperator, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/loadingstatusoperator.b5ce8e50.svg";
export { ForwardRef as ReactComponent };